// extracted by mini-css-extract-plugin
export var buttonContainer = "_5u-1";
export var fontSizeSelect = "_5u-3";
export var formatSelect = "_5u-2";
export var formats = "_5u-4";
export var hidden = "_5u-5";
export var icon = "_5u-6";
export var select = "_5u-0";